var cityList = [
    {
        "coding": "11",
        "city": "北京"
    },
    {
        "coding": "12",
        "city": "天津"
    },
    {
        "coding": "13",
        "city": "河北"
    },
    {
        "coding": "14",
        "city": "山西"
    },
    {
        "coding": "15",
        "city": "内蒙古"
    },
    {
        "coding": "21",
        "city": "辽宁"
    },
    {
        "coding": "22",
        "city": "吉林"
    },
    {
        "coding": "23",
        "city": "黑龙江"
    },
    {
        "coding": "31",
        "city": "上海"
    },
    {
        "coding": "32",
        "city": "江苏"
    },
    {
        "coding": "33",
        "city": "浙江"
    },
    {
        "coding": "34",
        "city": "安徽"
    },
    {
        "coding": "35",
        "city": "福建"
    },
    {
        "coding": "36",
        "city": "江西"
    },
    {
        "coding": "37",
        "city": "山东"
    },
    {
        "coding": "40",
        "city": "重庆"
    },
    {
        "coding": "41",
        "city": "河南"
    },
    {
        "coding": "42",
        "city": "湖北"
    },
    {
        "coding": "43",
        "city": "湖南"
    },
    {
        "coding": "44",
        "city": "广东"
    },
    {
        "coding": "45",
        "city": "广西"
    },
    {
        "coding": "46",
        "city": "海南"
    },
    {
        "coding": "51",
        "city": "四川"
    },
    {
        "coding": "52",
        "city": "贵州"
    },
    {
        "coding": "53",
        "city": "云南"
    },
    {
        "coding": "54",
        "city": "西藏"
    },
    {
        "coding": "61",
        "city": "陕西"
    },
    {
        "coding": "62",
        "city": "甘肃"
    },
    {
        "coding": "63",
        "city": "青海"
    },
    {
        "coding": "64",
        "city": "宁夏"
    },
    {
        "coding": "65",
        "city": "新疆"
    }

]

export default {
    cityList
}


// WEBPACK FOOTER //
// ./src/views/LuckyNumPay/city.js